import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const SessionDumbbell = (props: SvgProps) => (
  <Svg viewBox='0 0 9 9' {...props}>
    <Path
      d='M6.059 3.095 3.25 5.905M2.668 8 1.154 6.486M4.786 7.78 1.374 4.368M6.64 1l1.514 1.514M4.522 1.22l3.413 3.412'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
